import { render, staticRenderFns } from "./Academy_TD.vue?vue&type=template&id=3fc089c6"
import script from "./Academy_TD.vue?vue&type=script&lang=js"
export * from "./Academy_TD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports